module.exports = __webpack_public_path__ + "img/flavor6.f063fb5e.svg";